export const compareFormDataAndServiceOrder = <T extends Record<string, unknown>>(
  formData: T,
  serviceOrder: T,
) => {
  const changedFields = Object
    .keys(formData)
    .filter(field => formData[field] !== serviceOrder[field]);

  const changes = changedFields.map(field => ({
    field,
    formDataValue: formData[field],
    serviceOrderValue: serviceOrder[field],
  }));

  return { changes, changedFields };
};